@for (deliveriesByCountry of deliveriesByCountries | keyvalue; track deliveriesByCountry.key) {
  <app-delivery-report-other-deliveries-by-group
    [deliveriesByCountry]="deliveriesByCountry"
    [isPrintView]="isPrintView()"
  ></app-delivery-report-other-deliveries-by-group>
}
